<template>
  <div class="container blog page">
    <div class="row">
      <div class="body-pane col-lg-8">
        <div class="content entry">
          <hgroup>
            <h2>Morning Coffee: Day 2</h2>
            <p>Added: October 20, 2026</p>
          </hgroup>
          <p>I spent yesterday configuring my machine in anticipation of this new project. I have to also install ServiceNow but I don't know which version they are using. There are still several unknowns during this onboarding process. It's exciting. I'm ready to work!
          </p>
        </div>
        <div class="content entry">
          <hgroup>
            <h2>Starting new part-time project today.</h2>
            <p>Added: October 19, 2026</p>
          </hgroup>
          <p>It has been a crazy year, to say the least. No one wants to hear about that, but I am starting a new part-time gig today and let's hope that goes well.</p>
        </div>

        <div class="content entry">
          <hgroup>
            <h2>Music Videos Lately Have Really Gone Downhill Lately</h2>
            <p>Added: August 27, 2025</p>
          </hgroup>
          <p>I have been watching VEVO Pop on Pluto TV over the last couple years as I work. I notice many of the videos are just terrible. Aside from the big-budget ones from real famous names we all know, a majority of them are poop.</p>
          <p>In 1997, I graduated from the Art Institute of Phoenix and I wanted to be a Music Video Director, so I judge music videos pretty harshly.  Gone are the days of Thriller and Purple Rain, now it all seems really unimaginative.  I wonder if I can get some sponsors so I can hire a crew to make my videos. hmm....</p>
        </div>

        <div class="content entry">
          <hgroup>
            <h2>BLOG: Cuz people still do that...?</h2>
            <p>Added: August 27, 2025</p>
          </hgroup>
          <p>Sometimes I wonder what information I should reveal here. I mean, this exists for me to find work and put myself out there. Do I really want to air my dirty laundry here? On one hand, I feel like I should be transparent and show I am a real human, and on the other hand, I have 5 fingers.</p>
        </div>
      </div>
      <div class="aux col-lg-4">
        <div class="ad">
          <h3>NOW AVAILABLE EVERYWHERE MUSIC IS STREAMED</h3>
          <img src="../assets/Rhystron-CD-2.webp" width="100%" alt="Rhystron album cover: There'll Be No Mercy" />
        </div>

        <div class="ad">
          <h3>PREVIOUS RELEASE</h3>
          <img src="../assets/Rhystron-CD-UiB.webp" width="100%" alt="Rhystron album cover: Ugly in Blue" />
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'BlogView',
}
</script>
